// src/index.tsx
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import BlogPage from './current/BlogPage';
import BlogPostPage from './current/BlogPostPage';
import ManifestoPage from './current/ManifestoPage';
import OneHotPage from './current/OneHotPage';
import RouterPlaygroundPage from './current/RouterPlaygroundPage';
import { PostHogProvider } from 'posthog-js/react'

const options = {
  api_host: process.env.REACT_APP_PUBLIC_POSTHOG_HOST,
}

const rootElement = document.getElementById('root');
if (!rootElement) throw new Error('Failed to find the root element');
const root = ReactDOM.createRoot(rootElement);

const posthogKey = process.env.REACT_APP_PUBLIC_POSTHOG_KEY;

function getAppForPath() {
  const path = window.location.pathname;
  if (path === '/blog' || path === '/blog/') {
    return <BlogPage />;
  }
  if (path.startsWith('/blog/')) {
    return <BlogPostPage />;
  }
  if (path === '/onehot' || path === '/onehot/') {
    return <OneHotPage />;
  }
  if (path === '/manifesto' || path === '/manifesto/') {
    return <ManifestoPage />;
  }
  if (
    path === '/routerarena-playground' ||
    path === '/routerarena-playground/'
  ) {
    return <RouterPlaygroundPage />;
  }
  return <App />;
}

// Render with or without PostHog depending on whether key is available
if (posthogKey) {
  root.render(
    <React.StrictMode>
      <PostHogProvider
        apiKey={posthogKey}
        options={options}
      >
        {getAppForPath()}
      </PostHogProvider>
    </React.StrictMode>
  );
} else {
  console.warn('PostHog API key not found, running without analytics');
  root.render(
    <React.StrictMode>
      {getAppForPath()}
    </React.StrictMode>
  );
}
